import { render } from "./ProviderSignatureAnnotation.vue?vue&type=template&id=41e9d452&scoped=true"
import script from "./ProviderSignatureAnnotation.vue?vue&type=script&lang=js"
export * from "./ProviderSignatureAnnotation.vue?vue&type=script&lang=js"

import "./ProviderSignatureAnnotation.vue?vue&type=style&index=0&id=41e9d452&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e9d452"]])

export default __exports__